<template>
  <div class="pay">
    <!-- 邮寄地址 -->
    <router-link class="tips_backhome" v-if="isShowTopTips" to="/home">
      <span class="text_tips_pay">{{ textTips }}</span>
      <span class="text_backhome">点击返回主页</span>
    </router-link>

    <!-- 广告页view -->
    <swiper
      :options="swiperOption"
      v-if="requestStatus == 7 && advertArr.length > 0"
    >
      <swiper-slide
        v-for="(item, index) in advertArr"
        :key="'advertArr' + index"
      >
        <img
          @click="bindAdvert(item)"
          style="display: block; width: 100%"
          class="advertArr-img"
          :src="item.advertImg"
        />
      </swiper-slide>

      <div class="swiper-pagination" slot="pagination"></div>
      <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
    </swiper>

    <SetNavBar :typeId="typeId" :step="step" v-if="isShowTopTips"></SetNavBar>
    <div
      :style="{
        'margin-top': pageMarginTop,
        'margin-bottom': pageMarginBottom,
      }"
    >
      <div class="mailaddress" v-if="showAddressArea">
        <div class="address_line">
          <div class="red-Parallelogram-half"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram-half"></div>
        </div>
        <!--userGetPrintType= 1在这里 -->
        <div
          v-if="
            userGetPrintType == 1 ||
            userGetPrintType == 3 ||
            userGetPrintType == 5 ||
            userGetPrintType == 7 ||
            userGetPrintType == 8 ||
            userGetPrintType == 1001 ||
            userGetPrintType == 1004 ||
            userGetPrintType == 1007 ||
            userGetPrintType == 1010 ||
            userGetPrintType == 1011
          "
        >
          <div class="address_title">
            <div class="weui-cell__bd">
              <div class="p-address-name" id="receiverName">
                收件人：{{ receiverName }}
              </div>
            </div>

            <div class="weui-cell__ft receiver-tel">{{ receiverTel }}</div>
          </div>

          <div class="weui-media-box__desc address_detail" v-if="!isShowMail">
            {{ receiverAddr }}
          </div>
          <div class="express-Logistics" v-if="isShowMail">
            <div class="receiver-address">
              <div class="express-left">
                <div class="text-get">收</div>
              </div>

              <div class="receiverAddr">{{ receiverAddr }}</div>
            </div>
            <div class="d_line"></div>
            <div class="v-dotted"></div>
            <div class="receiver-address">
              <div class="logo-express">
                <img
                  class="express-logo"
                  v-if="expressFlag == 'EMS'"
                  src="../assets/ems.png"
                />
                <img
                  class="express-logo"
                  v-if="expressFlag == 'SF'"
                  src="../assets/sf.png"
                />
                <img
                  class="express-logo"
                  v-if="expressFlag == 'ANE'"
                  src="../assets/ane.png"
                />
                <img
                  class="express-logo"
                  v-if="expressFlag == 'JD'"
                  src="../assets/jd_logo.png"
                />
                <img
                  class="express-logo"
                  v-if="expressFlag == 'STO'"
                  src="../assets/ST.png"
                />
                <img
                  class="express-logo"
                  v-if="expressFlag == 'YD'"
                  src="../assets/YD.png"
                />
                <img
                  class="express-logo"
                  v-if="expressFlag == 'ZTO'"
                  src="../assets/ZTO.png"
                />
                <img
                  class="express-logo"
                  v-if="expressFlag == 'ZGYZ'"
                  src="../assets/ZGYZ.png"
                />
              </div>

              <div class="express-log">{{ logTracksText }}</div>
              <button
                class="express-d"
                v-if="isShowExpressBtn"
                @click="goLogisticsTrack"
              >
                物流详情
              </button>
            </div>
          </div>
        </div>
        <!-- userGetPrintType= 2在这里 -->
        <div
          class="address_by_self"
          v-if="
            userGetPrintType == 2 ||
            userGetPrintType == 4 ||
            userGetPrintType == 6 ||
            userGetPrintType == 1002
          "
        >
          <!--requestStatus<5  -->
          <div v-if="requestStatus > 100">
            <div>您的病历自提申请{{ requestStatusName }}</div>
            <div>{{ userCancelCause }}</div>
            <div>如需病历，可再次申请</div>
          </div>
          <div v-if="requestStatus < 5">
            <div>您的自提申请需要医院操作人员进一步审核</div>
            <div>请耐心等待</div>
          </div>
          <div
            v-if="
              requestStatus == 5 && (selfPickupCode == null || selfPickupCode == '') && verifyFlag == 0
            "
          >
            <div>您的自提申请需要医院操作人员进一步审核</div>
            <div>请耐心等待</div>
          </div>
          <div
            v-if="
              requestStatus == 5 && (selfPickupCode == null || selfPickupCode == '') && verifyFlag == 1
            "
          >
            <div>病案复印已排队，等待自提通知</div>
            <div>凭自提码提取病历</div>
          </div>

          <div
            class="selfcode_cell"
            v-if="
              requestStatus == 5 && verifyFlag == 1 && (selfPickupCode != null && selfPickupCode != '')
            "
            @click="showCodeImage"
          >
            <div class="selfCodeItem ml_cell">
              <div style="margin-top: 10px">
                {{ selfCodeName }}
                <span class="textSelfPickeCode">{{ selfPickupCode }}</span>
              </div>
              <img class="selfpickPic" src="../assets/click_self.svg" />
            </div>
            <div class="my_line"></div>
            <div class="pickup_address" v-if="showSelfAddress">
              <img class="location_img" src="../assets/location_logo.svg" />
              自提地址：{{ selfAddress }}
            </div>
            <div class="my_line" v-if="showSelfAddress"></div>
            <div class="pickup_address">
              <img class="location_img" src="../assets/time_logo.svg" />
              截止时间：{{ selfPickupExprireTime }}
            </div>
            <div class="my_line"></div>
            <div class="tipsSelf ml_cell">
              <span class="zhu">注：</span
              >窗口自提时请携带相关证件并出示自提码。
            </div>
          </div>

          <div v-if="requestStatus == 7">
            <div class="selfCodeItem">
              <img class="selfComplete" src="../assets/selfcomp.svg" />
            </div>
            <div>完成时间：{{ expressTime }}</div>
          </div>
        </div>
        <div class="address_line">
          <div class="red-Parallelogram-half"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram"></div>
          <div class="blue-Parallelogram"></div>
          <div class="red-Parallelogram-half"></div>
        </div>
      </div>
      <!-- er维码显示 -->
      <div
        class="enlargerLay"
        v-show="isShowCodeImage && isZhongRi"
        @click="closePic"
      >
        <div class="selfcode_imagezr" ref="qrCodeUrl"></div>
        <div class="selfcode_imagezr1">{{ selfPickupCode }}</div>
      </div>
      <!-- 一维码显示 -->
      <div
        class="enlargerLay"
        v-show="isShowCodeImage && !isZhongRi"
        @click="closePic"
      >
        <img id="barcode" class="selfcode_image" />
      </div>
      <!-- 申请信息 -->
      <div class="paddress">
        <information class="information">
          <span slot="title">申请信息</span>
          <ul slot="hideinfo">
            <li class="hideitem" :id="lineShow">
              <span>申请编号</span>
              <span>{{ requestId }}</span>
            </li>
            <li class="hideitem" v-if="isShowMsg">
              <span>{{ cancelMsg }}</span>
            </li>
            <li class="hideitem cancelapply" v-if="isShowCancelBtn">
              <span></span>
              <button
                class="canceapplych"
                @click="bindCancel()"
                :disabled="disabledCancel"
              >
                取消申请
              </button>
            </li>
            <li class="hideitem">
              <span>{{ userMrNoName }}</span>
              <span>{{ userMrNo }}</span>
            </li>
          </ul>
          <ul slot="nohideinfo">
            <li class="hideitem">
              <span>申请状态</span>
              <span :style="{ color: statusColor, 'font-weight': 'bold' }">{{
                requestStatusName
              }}</span>
            </li>
            <li class="hideitem">
              <span class="hos-name">就医医院</span>
              <span>{{ hosShortName }}</span>
            </li>
            <li class="hideitem">
              <span>患者姓名</span>
              <span>{{ patientName }}</span>
            </li>
            <li class="hideitem">
              <span>{{ inDateName }}</span>
              <span>{{ userHosInDate }}</span>
            </li>
            <li
              class="hideitem"
              v-if="userHosOutDate != '' && inDateName != '就诊时间'"
            >
              <span>{{ outDateName }}</span>
              <span>{{ userHosOutDate }}</span>
            </li>
            <li
              class="hideitem"
              v-if="
                userHosOutDate == '' &&
                requestStatus < 7 &&
                inDateName != '就诊时间'
              "
            >
              <span>出院时间</span>
              <button
                class="btnUpdateDate"
                :disabled="disabledDate"
                @click="clickAddOutDate"
              >
                {{ textOutDate }}
              </button>
            </li>
            <van-popup v-model="showPickerDate" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="onConfirm"
                @cancel="showPickerDate = false"
              />
            </van-popup>
          </ul>
        </information>
        <information v-if="isShowPackage">
          <span slot="title" class="pay-title">复印用途</span>
          <span slot="moreinfo"></span>
          <ul slot="nohideinfo">
            <li
              class="hideitem"
              v-for="(item, index) in userSelectMrItems"
              :key="'userSelectMrItems' + index"
            >
              <span>{{ item.itemName }}</span>
              <span>{{ item.userSelectCopies }}份</span>
            </li>
          </ul>
        </information>
        <information class="information" v-if="isShowPayed">
          <span slot="title">已支付费用</span>
          <ul slot="hideinfo">
            <li class="hideitem" v-if="pageNum > 0 && requestStatus == 7">
              <span>复印费页数</span>
              <span>{{ pageNum }}页</span>
            </li>
            <li class="hideitem" v-if="requestSetNum > 0 && requestStatus == 7">
              <span>复印份数</span>
              <span>{{ requestSetNum }}份</span>
            </li>
            <li
              class="hideitem"
              v-for="(item, index) in payedItemFees"
              :key="'payedItemFees' + index"
            >
              <span>{{ item.feeItemDispName }}</span>
              <span v-if="item.feeFinalFee < 0" id="paied_final_fee_b"
                >{{ item.feeFinalFee }}元</span
              >
              <span v-if="item.feeFinalFee >= 0" id="paied_final_fee"
                >{{ item.feeFinalFee }}元</span
              >
            </li>
          </ul>
          <ul slot="nohideinfo">
            <li class="hideitem">
              <span class="total-title">实付款</span>
              <span id="totalFee">{{ actualPayFee }}元</span>
            </li>
          </ul>
        </information>
        <information class="information" v-if="isShowPaying">
          <span slot="title" class="no_payed">{{ payTitle }}</span>
          <ul slot="hideinfo">
            <li class="hideitem" v-if="pageNum > 0 && requestStatus == 7">
              <span>复印费页数</span>
              <span>{{ pageNum }}页</span>
            </li>
            <li class="hideitem" v-if="requestSetNum > 0 && requestStatus == 7">
              <span>复印份数</span>
              <span>{{ requestSetNum }}份</span>
            </li>
            <li
              class="hideitem"
              v-for="(item, index) in payingItemFees"
              :key="'payedItemFees' + index"
            >
              <span>{{ item.feeItemDispName }}</span>
              <span id="no_pay_fee">{{ item.feeFinalFee }}元</span>
            </li>
          </ul>
          <ul slot="nohideinfo">
            <li class="hideitem">
              <span class="total-title">{{ totalTitle }}</span>
              <span id="totalFee">{{ totalPayingFee }}元</span>
            </li>
          </ul>
        </information>
        <!-- 发票 -->
        <information
          v-if="isPrintInvoice && voucherStatus == 2 && requestStatus === 7"
        >
          <span slot="title" class="pay-title">复印费发票</span>
          <span slot="moreinfo"></span>
          <ul
            slot="nohideinfo"
            v-for="(item, index) in invoiceList"
            :key="'invoiceList' + index"
          >
            <li class="hideitem">
              <span>{{ item.feePartyName }}</span>
              <button class="seefapiao" @click="gofapiao(item.invoiceUrl)">
                查看并打印发票
              </button>
            </li>
          </ul>
        </information>
      </div>
    </div>
    <div class="bottom-view"></div>
    <van-button
      v-if="isShowPayBtn"
      type="primary"
      size="large"
      class="btn-next"
      safe-area-inset-bottom
      @click="pay"
      :disabled="disabledPay"
      color="#1aad19"
      >支付</van-button
    >
    <div class="pay-popup" v-if="showPayTips">
      <!-- v-if= "{{pickupOut == 1}}" -->
      <div class="popup-paytips" v-if="pickupOut == 1 && feeItem_Type == false">
        <img class="pay-notice" src="../assets/pay_notice.png" />
        <div class="popup-content">
          <div class="content-list">
            <div class="content-num">1</div>
            <div class="content-item">
              需支付费用是
              <span>预付复印费</span
              >，病案室打印后，我们会根据实际病历页数进行预收复印费的
              <span>多退少补</span>
            </div>
          </div>
          <div class="content-list">
            <div class="content-num">2</div>
            <div class="content-item">
              需支付的邮寄费用：<span>自提用户</span>预交的邮寄费，将在自提完成后<span>2-5个工作日</span>原路退还到患者的支付账户
            </div>
          </div>

          <div class="content-list">
            <div class="content-num">3</div>
            <div class="content-item">
              <span>6小时</span>内未支付，订单将自动关闭
            </div>
          </div>
          <button class="btn-agree" @click="closePayTips">我知道啦</button>
        </div>
      </div>
      <!--  v-if= "{{pickupOut != 1}}" -->

      <div class="popup-paytips" v-if="pickupOut != 1 && feeItem_Type == false">
        <img class="pay-notice" src="../assets/pay_notice.png" />
        <div class="popup-content">
          <div class="content-list">
            <div class="content-num">1</div>
            <div class="content-item">
              需支付费用是
              <span>预付复印费</span
              >，病案室打印后，我们会根据实际病历页数进行预收复印费的
              <span>多退少补</span>
            </div>
          </div>
          <div class="content-list">
            <div class="content-num">2</div>
            <div class="content-item">
              <span>6小时</span>内未支付，订单将自动关闭
            </div>
          </div>
          <button class="btn-agree" @click="closePayTips">我知道啦</button>
        </div>
      </div>

      <!-- <div v-if="pickupOut ==1 && feeItem_Type == false"> -->
      <div class="popup-paytips" v-if="feeItem_Type">
        <img class="pay-notice" src="../assets/pay_notice.png" />
        <div class="popup-content">
          <div class="content-list">
            <div class="content-num">1</div>
            <div class="content-item">
              需支付费用是
              <span>实际费用</span>
            </div>
          </div>
          <div class="content-list">
            <div class="content-num">2</div>
            <div class="content-item">
              <span>6小时</span>内未支付，订单将自动关闭
            </div>
          </div>
          <button class="btn-agree" @click="closePayTips">我知道啦</button>
        </div>
      </div>

      <!-- <div class="popup-paytips" v-if= "pickupOut != 1  && hosFeeItemType">
        <img class="pay-notice" src="../assets/pay_notice.png" />
        <div class="popup-content">
          <div class="content-list">
            <div class="content-num">1</div>
            <div class="content-item">
              需支付费用是
              <span>实际费用</span>
            </div>
          </div>
          <div class="content-list">
            <div class="content-num">2</div>
            <div class="content-item">
              <span>6小时</span>内未支付，订单将自动关闭
            </div>
          </div>
          <button class="btn-agree" @click="closePayTips">我知道啦</button>
        </div>
      </div> -->
    </div>
    <div class="paytips" v-if="showBottomPayTips">
      <!-- v-if="{{pickupOut ==1}}" -->
      <div v-if="pickupOut == 1 && feeItem_Type == false">
        <div class="paytips-content">
          • 需支付费用是
          <span>预付复印费</span
          >，病案室打印后，我们会根据实际病历页数进行预收复印费的
          <span>多退少补</span>
        </div>
        <div class="paytips-content">
          •
          需支付的邮寄费用：<span>自提用户</span>预交的邮寄费，将在自提完成后<span>2-5个工作日</span>原路退还到患者的支付账户
        </div>
        <div class="paytips-content">
          •
          <span>6小时</span>内未支付，订单将自动关闭
        </div>
      </div>
      <!-- v-if="{{pickupOut !=1}}" -->
      <div v-if="pickupOut != 1 && feeItem_Type == false">
        <div class="paytips-content">
          • 需支付费用是
          <span>预付复印费</span
          >，病案室打印后，我们会根据实际病历页数进行预收复印费的
          <span>多退少补</span>
        </div>
        <div class="paytips-content">
          •
          <span>6小时</span>内未支付，订单将自动关闭
        </div>
      </div>
      <div v-if="feeItem_Type">
        <div class="paytips-content">
          • 需支付费用是
          <span>实际费用</span>
        </div>
        <div class="paytips-content">
          •
          <span>6小时</span>内未支付，订单将自动关闭
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
Vue.use(VueAwesomeSwiper);

import Information from "../components/Information.vue";
import Util from "../utils/util.js";
import Vue from "vue";
import { AddressList, Dialog, Toast, Notify, Popup } from "vant";
Vue.use(AddressList).use(Dialog).use(Toast).use(Notify).use(Popup);
// Dialog({ message: "提示111" });
import wx from "weixin-js-sdk";
// import mixin from "../utils/mixin-1.6.0.js"
import JsBarcode from "jsbarcode";
// import JsQrcode from "jsqrcode";

import SetNavBar from "../components/SetNavBar.vue";
import Base64 from "../utils/base64.min";
let msg = "";
let hosId = "";
let prePayFlag;
let pickupOut = 1;
import QRCode from "../../node_modules/qrcodejs2/qrcode.js";
export default {
  name: "Pay",
  data() {
    return {
      showAddressArea: true,
      requestId: "",
      userCancelCause: "",
      detailRequestc: {},
      userMrNoName: "",
      requestStatusName: "",
      userMrNo: "",
      requestStatus: "",
      statusColor: "#333333",
      hosShortName: "",
      patientName: "",
      userHosInDate: "",
      userHosOutDate: "",
      outDate: "",
      inDateName: "入院时间",
      outDateName: "出院时间",
      userGetPrintType: "",
      userSelectMrItems: "",
      payedItemFees: [],
      payedItemFeesArr: [],
      payingItemFeesArr: [],
      pageNum: "",
      requestSetNum: "",
      payingItemFees: "",
      //   foractualPayFee:'',
      actualPayFee: "",
      selfPickupCode: "",
      receiverName: "",
      receiverTel: "",
      receiverAddr: "",
      selfCodeTips: "",
      selfCodeName: "",
      pickupMode: "",
      selfPickupExprireTime: "",
      hiddenCancel: true,
      splice: "",
      isShowPackage: true,
      showSelfAddress: false,
      isShowMsg: false,
      isShowCancelBtn: false,
      cancelMsg: "",
      verifyFlag: "",
      lineShow: "",
      isShowPayed: false,
      isShowPayBtn: false,
      isShowPaying: false,
      payTitle: "",
      totalTitle: "",
      disabledCancel: false,
      disabledPay: false,
      selfPickupPlace: "",
      codePathUrl: "",
      isShowCodeImage: false,
      isShowMail: false,
      expressNo: "",
      expressFlag: "",
      logTracksText: "",
      isShowExpressBtn: false,
      expressCompany: "",
      expressTime: "",
      isShowTopTips: false,
      textTips: "",
      step: 5,
      typeId: 2,
      disabledDate: false,
      showPickerDate: false,
      minDate: new Date(1949, 10, 1),
      maxDate: addDate(getCurrenDate(), 7),
      currentDate: new Date(),
      textOutDate: "添加出院时间",
      pageMarginTop: "0",
      showPayTips: false,
      showBottomPayTips: false,
      pickupOut: "",
      pageMarginBottom: "",
      voucherDownloadUrl: "",
      voucherStatus: "",
      isPrintInvoice: false,
      feeItem_Type: false,
      hosFeeItemType: "",
      invoiceList: [],
      isZhongRi: false,
      // 埋点
      mdreferrer: "",
      mdreferrer_title: "",
      // qrView:''
      isFirstDay: false,

      advertArr: [],
      mediacl_url: "https://gateway.vmeeting.cn",
      client_id: "kh516272457669649577",
      client_secret: "kingdom",

      swiperOption: {
        slidesPerView: 1,
        // 设置分页器
        pagination: {
          el: ".swiper-pagination",
          // 设置点击可切换
          clickable: true,
        },
        // 设置前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 设置自动轮播
        autoplay: {
          delay: 5000, // 5秒切换一次
        },
        // 设置轮播可循环
        loop: true,
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter");
    console.log("thisInBeforeRouteEnter", this);
    next((vm) => {
      console.log("thisInBeforeRouteEnterNext", this);
      console.log("vm", vm);
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
      // console.log(vm.getMsg());
      vm.mdreferrer = from.path;
      if (from.name == "" || from.name == null || from.name == undefined) {
        vm.mdreferrer_title = "无上一页";
      } else {
        vm.mdreferrer_title = from.name;
      }
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
    });
  },
  created() {
    let payId = this.$route.params.payId;
    console.log(this.$route.params);
    prePayFlag = this.$route.params.preFlag;
    console.log(prePayFlag);
    if (prePayFlag == 1) {
      this.isShowTopTips = true;
      this.textTips = "您还没有支付，请尽快进行支付操作";
      this.pageMarginTop = "85px";
      this.showPayTips = true;
    } else if (prePayFlag == 2) {
      this.isShowTopTips = true;
      this.textTips = "申请成功，等待审核";
      this.pageMarginTop = "85px";
    } else {
      this.isShowTopTips = false;
      this.pageMarginTop = "0";
    }
    let requestId;
    if (payId != null) {
      requestId = payId;
    }
    this.getTicket();
    const params = {
      requestId: requestId,
    };
    this.detailRequest(params);

    this.getAdvert(this);
  },
  mounted() {
    var everypage = JSON.parse(localStorage.getItem("everypage"));
    var payinformation = everypage.payinformation + 1;
    everypage.payinformation = payinformation;
    if (payinformation == 1) {
      this.isFirstDay = true;
    } else {
      this.isFirstDay = false;
    }
    localStorage.setItem("everypage", JSON.stringify(everypage));

    console.log(this, "这是mounted");
    var mdreferrer_title = localStorage.getItem("title");
    if (
      mdreferrer_title == "" ||
      mdreferrer_title == undefined ||
      mdreferrer_title == null
    ) {
      // mdreferrer = '没有上一页'
      mdreferrer_title = "没有上一页";
    }
    var title = this.$route.name;
    localStorage.setItem("mdreferrer_title", mdreferrer_title);
    localStorage.setItem("title", title);
    var url = this.$route.path;
    var url_path = this.$route.path;
    var is_first_Day = this.isFirstDay;
    var preview = "MPViewScreen";
    // var mdreferrer = this.mdreferrer;
    // var mdreferrer_title = this.mdreferrer_title;
    this.$util.BuriedPoint(
      title,
      url,
      url_path,
      is_first_Day,
      preview,
      mdreferrer_title
    );
  },

  methods: {
    // 获取行为日志
    getApplyLog(params) {
      this.$server.getApplyLog(params).then((res) => {
        if (res.result == 1) {
          console.log("获取log成功____________________________");
        }
      });
    },
    creatQrCode(test) {
      // var test = this.user
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        // text: 'https://blog.csdn.net/weixin_42601136', // 需要转换为二维码的内容，链接二维码
        text: JSON.stringify(test), // 需要转换为二维码的内容，文字二维码
        width: 200,
        height: 200,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
      return qrcode;
    },
    detailRequest(params) {
      let that = this;
      this.$server.detailRequest(params).then((data) => {
        if (data.result == 1) {
          console.log("请求成功");
          console.log(data);
          console.log(data.result, "90909090909090090090900909000");
          console.log(this.$util.aesDecrypt(data.request))
          // this.detailRequestc = JSON.parse(this.$util.aesDecrypt(data.request));
          try{
            this.detailRequestc = JSON.parse(this.$util.aesDecrypt(data.request));
          }catch (e) {
            console.log(e)
          }
          this.invoiceList = data.invoiceList;
          console.log("00000");
          console.log(this.detailRequestc);
          console.log("111111");
          this.isPrintInvoice = this.detailRequestc.isPrintInvoice;
          this.hosFeeItemType = this.detailRequestc.hosFeeItemType;
          this.voucherStatus = this.detailRequestc.voucherStatus;

          console.log('zheshinaliya',this.isPrintInvoice);
          console.log(this.detailRequestc.receiverName,'this.detailRequestc.receiverName')
          console.log(this.voucherStatus);
          console.log(this.detailRequestc.pickupOut);
          this.pickupOut = this.detailRequestc.pickupOut;
          console.log(pickupOut);
          console.log("console.log(pickupOut)");
          this.requestId = this.detailRequestc.requestId;
          this.userCancelCause = this.detailRequestc.userCancelCause;
          this.voucherDownloadUrl = this.detailRequestc.voucherDownloadUrl;
          console.log(this.voucherDownloadUrl);
          this.userMrNo = Base64.decode(this.detailRequestc.userMrNo);
          this.requestStatus = this.detailRequestc.requestStatus;
          this.hosShortName = Base64.decode(this.detailRequestc.hosShortName);
          this.patientName = Base64.decode(this.detailRequestc.patientName);
          this.selfPickupPlace = this.detailRequestc.selfPickupPlace;
          if (this.hosFeeItemType == "FEE_ITEM_SET") {
            this.feeItem_Type = true;
          }
          console.log(this.feeItem_Type);
          if (this.detailRequestc.userHosInDate != null) {
            this.userHosInDate = this.$util.normalString(
              this.detailRequestc.userHosInDate.substr(0, 10)
            );
          }

          this.userGetPrintType = this.detailRequestc.userGetPrintType;
          this.codePathUrl = this.detailRequestc.generatePath;
          this.expressNo = this.detailRequestc.expressNo;
          this.expressCompany = this.detailRequestc.expressCompany;
          this.expressTime = this.detailRequestc.expressTime;
          if (this.detailRequestc.expressCompanyEntity != null) {
            this.expressFlag =
              this.detailRequestc.expressCompanyEntity.expressFlag;
          }
          hosId = this.detailRequestc.hosId;
          // if (prePayFlag == 1) {
          //   this.pay();
          // }
          let obj = {
            hosId: hosId,
            wxId: localStorage.getItem("wxId"),
            printType: this.userGetPrintType,
          };
          this.getPickupPlace(obj);
          this.userSelectMrItems = this.detailRequestc.userSelectMrItems;
          this.pageNum = this.detailRequestc.pageNum;
          this.requestSetNum = this.detailRequestc.requestSetNum;
          this.requestPayingItemFees =
            this.detailRequestc.requestPayingItemFees;
          this.payedItemFees = this.detailRequestc.requestPayedItemFees;
          this.payingItemFees = this.detailRequestc.requestPayingItemFees;
          this.actualPayFee = this.getFee(this.detailRequestc.actualPayFee);
          this.userHosOutDate = this.detailRequestc.userHosOutDate;
          if (this.userHosOutDate != null) {
            this.userHosOutDate = this.$util.normalString(
              this.userHosOutDate.substr(0, 10)
            );
          }
          this.selfPickupCode = this.detailRequestc.selfPickupCode;
          console.log(this.selfPickupCode);
          if (hosId == 1019) {
            // var segs = [{
            //   data:this.selfPickupCode,
            //   mode:'numeric',
            // }]
            // let url1 ='';
            let test = this.detailRequestc.selfPickupCode;
            this.isZhongRi = true;
            this.creatQrCode(test);
            // QRCode("#barcode",{
            //   // console.log(err)
            //   // url1 = url
            //   // QRCode('barcode',{
            //   width: 100,
            //   height: 100,
            //   text: JSON.stringify(this.selfPickupCode),
            // // })

            // })
          } else {
            this.isZhongRi = false;
            if(this.detailRequestc.selfPickupCode!=null&&this.detailRequestc.selfPickupCode!=''){
              JsBarcode("#barcode", this.detailRequestc.selfPickupCode, {
                width: 4,
                height: 100,
              });
            }

          }

          this.verifyFlag = this.detailRequestc.verifyFlag;
console.log(this.detailRequestc.receiverName,'this.detailRequestc.receiverName')
          this.receiverName = this.normalString(
            this.detailRequestc.receiverName
          );
          this.receiverTel = this.normalString(this.detailRequestc.receiverTel);
          this.receiverAddr = this.normalString(
            this.detailRequestc.fullAddress
          );
          this.selfPickupExprireTime = this.normalString(
            this.detailRequestc.selfPickupExprireTime
          );
          this.pickupMode = this.detailRequestc.pickupMode;

          console.log(this.detailRequestc.pickupMode);
          if (this.pickupOut != undefined && this.pickupOut != null) {
            this.pageMarginBottom = "160px";
            console.log(this.pageMarginBottom);
            console.log("this.pageMarginBottom为60px");
          } else {
            this.pageMarginBottom = "0px";
          }
          console.log(this.pageMarginBottom);
          if (this.requestStatus > 4) {
            this.showBottomPayTips = false;
          }
          if (
            this.requestStatus == 5 &&
            this.verifyFlag == 1 &&
            this.selfPickupCode != null
          ) {
            // path = this.mRequestInfo.generatePath;
            this.selfCodeTips = "可自提";
            this.selfCodeName = "自提码：";
            if (this.pickupMode >= 20 || this.pickupMode == 2) {
              this.selfCodeTips = "可点击";
              this.selfCodeName = "自提序号：";
              this.selfPickupCode = this.selfPickupCode.substr(
                this.selfPickupCode.length - 4
              );
            }

            // this.selfCodeTips = this.selfCodeTips;
            // this.pickupMode = this.pickupMode;
            // this.selfCodeName = this.selfCodeName;
          }

          if (this.payedItemFees != null) {
            this.payedItemFeesArr.length = 0;
            for (let i = 0; i < this.payedItemFees.length; i++) {
              this.payedItemFee = new Object();
              this.payedItemFee.feeFinalFee = this.getFee(
                this.payedItemFees[i].feeFinalFee
              );
              this.payedItemFee.feeItemDispName =
                this.payedItemFees[i].feeItemDispName;
              this.payedItemFeesArr.push(this.payedItemFee);
            }
            console.log(this.payedItemFeesArr);
            this.isShowPayed = true;
            this.payedItemFees = this.payedItemFeesArr;
          } else {
            this.isShowPayed = false;
          }
          let totalPayingFee;
          if (this.payingItemFees != null) {
            totalPayingFee = 0;
            this.payingItemFeesArr.splice(0, this.payingItemFeesArr.length);

            // for (let i in this.payingItemFees) {
            for (var i = 0; i < this.payingItemFees.length; i++) {
              let payingItemFee = new Object();
              totalPayingFee += this.payingItemFees[i].feeFinalFee;
              payingItemFee.feeFinalFee = this.getFee(
                this.payingItemFees[i].feeFinalFee
              );
              payingItemFee.feeItemDispName =
                this.payingItemFees[i].feeItemDispName;

              this.payingItemFeesArr.push(payingItemFee);
            }

            if (totalPayingFee < 0) {
              (this.payTitle = "未退款费用"), (this.totalTitle = "未退款费用");
            }
            if (totalPayingFee >= 0) {
              (this.payTitle = "未支付费用"), (this.totalTitle = "需支付费用");
            }
            (this.isShowPaying = true),
              (this.payingItemFees = this.payingItemFeesArr),
              (this.totalPayingFee = this.getFee(totalPayingFee));
          } else {
            this.isShowPaying = false;
          }

          if (this.detailRequestc.wxId == "45") {
            this.userMrNoName = "就诊卡号";
          } else {
            this.userMrNoName = "住院号";
          }
          if (
            this.userGetPrintType == 7 ||
            this.userGetPrintType == 8 ||
            this.userGetPrintType == 9
          ) {
            // 中草药或者病案浏览进度设置为4步
            this.typeId = 1;
            this.step = 4;
          } else {
            this.typeId = 2;
            this.step = 5;
          }
          if (this.userGetPrintType == 3 || this.userGetPrintType == 4) {
            this.inDateName = "开始时间";
            this.outDateName = "截止时间";
            this.userMrNoName = "就诊卡号";
          }
          if (this.userGetPrintType == 7 || this.userGetPrintType == 8) {
            this.isShowPackage = false;
            this.inDateName = "就诊时间";
            this.userHosOutDate = "";
          }
          if (this.userGetPrintType == 9) {
            this.isShowPackage = false;
            this.showAddressArea = false;
          }
          if (this.requestStatus > 100) {
            this.statusColor = "#F04141";
          } else {
            this.statusColor = "#333333";
          }

          if (
            this.requestStatus == 1 ||
            this.requestStatus == 2 ||
            this.requestStatus == 3
          ) {
            this.requestStatusName = "业务受理";
          } else if (this.requestStatus == 4) {
            this.requestStatusName = "未支付";
            // this.showBottomPayTips = true;
            this.isShowPayBtn = true;
          } else if (this.requestStatus == 5 || this.requestStatus == 6) {
            this.isShowPayBtn = false;
            this.showBottomPayTips = false;
            this.showPayTips = false;
            this.isShowTopTips = false;
            this.pageMarginTop = "0";
            // this.textTips = "您已经支付成功，请耐心等待！";
            this.requestStatusName = "已付款";
          } else if (this.requestStatus == 7) {
            if (
              this.userGetPrintType == 1 ||
              this.userGetPrintType == 3 ||
              this.userGetPrintType == 5 ||
              this.userGetPrintType == 7 ||
              this.userGetPrintType == 8 ||
              this.userGetPrintType == 1001 ||
              this.userGetPrintType == 1004 ||
              this.userGetPrintType == 1007 ||
              this.userGetPrintType == 1010 ||
              this.userGetPrintType == 1011
            ) {
              this.requestStatusName = "已邮寄";
            } else if (
              this.userGetPrintType == 2 ||
              this.userGetPrintType == 4 ||
              this.userGetPrintType == 6 ||
              this.userGetPrintType == 1002 ||
              this.userGetPrintType == 1003 ||
              this.userGetPrintType == 1012 ||
              this.userGetPrintType == 1005 ||
              this.userGetPrintType == 1006 ||
              this.userGetPrintType == 1008 ||
              this.userGetPrintType == 1009
            ) {
              this.requestStatusName = "已自提";
            } else {
              this.requestStatusName = "业务完成";
            }
          } else if (this.requestStatus == 101) {
            this.requestStatusName = "审核不通过";
          } else if (this.requestStatus == 102) {
            //   that.setData({
            //     tipsContent: "您已经取消申请",
            //     tipsBgColor: "#f60"
            //   })
            this.requestStatusName = "用户取消";
          } else if (this.requestStatus == 103) {
            this.requestStatusName = "用户取消并退款";
          } else {
            this.requestStatusName = "系统关闭";
          }
          if (this.requestStatus <= 5 && this.verifyFlag == 0) {
            this.isShowCancelBtn = true;
            this.lineShow = "line-show";
          }
          if (this.requestStatus == 102) {
            this.isShowCancelBtn = false;
            this.lineShow = "";
          }
          if (this.requestStatus < 7 && this.verifyFlag == 1) {
            this.queryCancelRequest();
          }
          if (
            this.requestStatus == 7 &&
            (this.userGetPrintType == 1 ||
              this.userGetPrintType == 3 ||
              this.userGetPrintType == 5 ||
              this.userGetPrintType == 7 ||
              this.userGetPrintType == 8 ||
              this.userGetPrintType == 1001 ||
              this.userGetPrintType == 1004 ||
              this.userGetPrintType == 1007 ||
              this.userGetPrintType == 1010 ||
              this.userGetPrintType == 1011)
          ) {
            this.isShowMail = true;

            let arrayStr = this.expressNo.split("|");
            for (let i = 0; i < arrayStr.length; i++) {
              that.expressNo = arrayStr[i];
              that.getLogQuery();
            }
          }
          console.log(this.userMrNoName);
          // console.log(data.requests)
          // this.hosInfos = data.requests
          // console.log(this.hosInfos)
          let prepayFlag = this.detailRequestc.prepayFlag;
          // 未支付 未审核 预付款 控制是否显示底部未支付提示消息
          if (
            this.requestStatus == 4 &&
            this.verifyFlag == 0 &&
            prepayFlag == 1
          ) {
            this.showBottomPayTips = true;
          }
        } else if (data.result == 200) {
          console.log("2");
        }
      });
    },
    queryCancelRequest() {
      let params = {
        requestId: this.requestId,
      };
      this.$server.queryCancelRequest(params).then((res) => {
        // let msg = res.msg;
        if (res.result == 1) {
          this.lineShow = "line-show";
          this.isShowMsg = false;
          this.isShowCancelBtn = true;
        } else {
          this.lineShow = "";
          this.isShowMsg = true;
          this.cancelMsg = res.msg;
        }
      });
    },

    bindCancel: Util.throttle(function (e) {
      this.disabledCancel = true;
      console.log("bindCancel成功");
      let par = {
        requestId: this.requestId,
      };
      console.log(e, par);
      this.$server.detailRequest(par).then((data) => {
        if (data.result == 1) {
          this.detailRequestc = JSON.parse(this.$util.aesDecrypt(data.request));
          this.requestStatus = this.detailRequestc.requestStatus;
          this.verifyFlag = this.detailRequestc.verifyFlag;
          if (this.requestStatus <= 5 && this.verifyFlag == 0) {
            console.log("调用成功");
            msg = "取消成功";
            Dialog.confirm({
              title: "提示",
              message: "确认取消申请",
            })
              .then((res) => {
                // on confirm
                console.log(res);
                Toast.loading({
                  message: "取消中...",
                  forbidClick: true,
                });
                this.requestCancel(msg);
              })
              .catch(() => {
                // on cancel
              });
          }
          if (this.requestStatus < 7 && this.verifyFlag == 1) {
            msg = "您的取消申请登记成功，请耐心等待工作人员确认";

            Dialog.confirm({
              title: "提示",
              message: "您的申请已经审核，是否通知工作人员进行取消申请",
            })
              .then(() => {
                // on confirm
                this.requestCancel(msg);
              })
              .catch(() => {
                // on cancel
              });
          }
        }
        this.disabledCancel = false;
      });
    }, 2000),
    requestCancel(msg) {
      let params = {
        requestId: this.requestId,
      };
      this.$server.getRequestCancel(params).then((data) => {
        if (data.result == 1) {
          Toast(msg);
          this.isShowCancelBtn = false;
          this.isShowPayBtn = false;
          this.showBottomPayTips = false;
          this.textTip = "您已经取消，如需病历请重新申请";
          this.detailRequest({
            requestId: params.requestId,
          });
        }
      });
    },
    infoToInformation(index) {
      console.log(index);
      console.log(this.hosInfos[index]);
      this.payId = this.hosInfos[index].requestId;
    },

    normalString(str) {
      if (str == null || str == undefined) {
        return "";
      } else return Util.trim(str);
    },
    getFee(fee) {
      return this.dixTo(fee);
    },

    dixTo(x) {
      var f = parseFloat(x);
      if (isNaN(f)) {
        return false;
      }
      // eslint-disable-next-line no-redeclare
      var f = Math.round(x) / 100;
      var s = f.toString();
      var rs = s.indexOf(".");
      if (rs < 0) {
        rs = s.length;
        s += ".";
      }
      while (s.length <= rs + 2) {
        s += "0";
      }
      console.log(s);
      return s;
    },
    getTicket() {
      let wxId = localStorage.getItem("wxId");
      let urlStr = this.GLOBAL.BASE_URL + "v1/request/appletPay";
      let payUrl = encodeURI(urlStr);
      let params = {
        wxId: wxId,
        payUrl: payUrl,
      };
      this.$server.getTicket(params).then((res) => {
        if (res.result == 1) {
          console.log(res, "ooooooooooooo");
          if (res.data != null) {
            let jsAPISignature = res.data;
            //             let jsAPISignature ={
            //  "appId": "wx3e941ade7e2332d2",
            //  "timeStamp": 1663220780,
            //  "nonceStr": "m82t7nvh0v484864ydq8vlrx0ytft1tr",
            //  "package": "prepay_id=up_wx15134620390789905ab376ea2720840000",
            //  "signType": "RSA",
            //  "paySign": "kaDJDYGm6tgqYYOGzKygavfVEnYYhQEyQArEtNaI3JeT0OypG5v4GmXNPrGAQUV9T3/BiWveYi6ZrLubg/LEQksEnC29F60bDBNcYbe8xBY1YG3v9KJqz7hvcx7C2+CbGbzt0IT5DpzSKyVp38HnFbyrbpAdMTfup/CKDJ6KpB3W7Z8Kole1JiWsS3EbWfbri2Im45GgMmNauiallKUVmBNeCI36Tdg1LokaBvrAIzVroBKIoHBYTXdErDMdDT9ijAm8OTYiOp2wReHcoIwKQ3jVhcKHcU0QWMOzaZoHZSFe8RYTMdafxzVsLqAgj4PZh8nBamvd3uLiU/RzE+MM+w=="
            // };
            wx.config({
              // debug: true,
              appId: jsAPISignature.appId,
              timestamp: jsAPISignature.timeStamp,
              nonceStr: jsAPISignature.nonceStr,
              signature: jsAPISignature.paySign,
              jsApiList: ["chooseWXPay"],
            });
          }
        }
      });
    },
    pay() {
      let that = this;
      this.disabledPay = true;
      let params = {
        requestId: this.requestId,
        hosId: hosId,
        wxId: localStorage.getItem("wxId"),
      };
      this.$server.pay(params).then((res) => {
        console.log(res);
        //         var signature = {
        //  "appId": "wx3e941ade7e2332d2",
        //  "timeStamp": 1663220780,
        //  "nonceStr": "m82t7nvh0v484864ydq8vlrx0ytft1tr",
        //  "package": "prepay_id=up_wx15134620390789905ab376ea2720840000",
        //  "signType": "RSA",
        //  "paySign": "kaDJDYGm6tgqYYOGzKygavfVEnYYhQEyQArEtNaI3JeT0OypG5v4GmXNPrGAQUV9T3/BiWveYi6ZrLubg/LEQksEnC29F60bDBNcYbe8xBY1YG3v9KJqz7hvcx7C2+CbGbzt0IT5DpzSKyVp38HnFbyrbpAdMTfup/CKDJ6KpB3W7Z8Kole1JiWsS3EbWfbri2Im45GgMmNauiallKUVmBNeCI36Tdg1LokaBvrAIzVroBKIoHBYTXdErDMdDT9ijAm8OTYiOp2wReHcoIwKQ3jVhcKHcU0QWMOzaZoHZSFe8RYTMdafxzVsLqAgj4PZh8nBamvd3uLiU/RzE+MM+w=="
        // };
        wx.chooseWXPay({
          timestamp: res.signature.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          nonceStr: res.signature.nonceStr, // 支付签名随机串，不长于 32 位
          package: res.signature.pack, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
          signType: res.signature.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          paySign: res.signature.paySign, // 支付签名
          jsApiList: [res.signature.chooseWXPay],

          success: function () {
            that.isShowTopTips = false;
            that.isShowPayBtn = false;
            that.showBottomPayTips = false;
            that.pageMarginTop = 0;
            // that.
            Dialog.alert({
              message: "支付成功",
            }).then(() => {
              // on close
              let obj = {
                requestId: that.requestId,
              };
              localStorage.setItem("requestId", obj.requestId);

              //  Toast.loading({
              //     message: "正在更新支付操作",
              //     forbidClick: true,
              //   });
              setTimeout(function () {
                that.$router.push("/pay/" + obj.requestId + "/" + prePayFlag);
                // wx.hideLoading()
                // that.detailRequest(obj);
              }, 10);
              //
              window.location.reload();

              // that.detailRequest(obj);
              // that.$router.go(0)
              //  Toast.loading({
              //     message: "取消中...",
              //     forbidClick: true,
              //   });
              // setTimeout(function () {
              //   // that.$router.push("/pay/" + obj.requestId + "/" + prePayFlag);
              //   // wx.hideLoading()
              //     // that.detailRequest(obj);
              // }, 10000);

              if (hosId == "1019" || hosId == "1022") {
                if (
                  that.payedItemFees == null ||
                  that.payedItemFees.length < 1
                ) {
                  that.$router.push("/questionnaire/" + obj.requestId);
                }
              }
            });
          },
          complete: function () {
            that.disabledPay = false;
            let logparams = {
              userId: localStorage.getItem("userId"),
              phoneV: localStorage.getItem("os"),
              wxV: localStorage.getItem("version"),
              wxId: localStorage.getItem("wxId"),
              pId: 1,
              type: localStorage.getItem("selectTypeLog"),

              // hosId: hosId,
              // bType: selectHbsType.type,
            };
            this.getApplyLog(logparams);
          },
        });
      });
    },
    /**
     * 获取自提地址
     */
    getPickupPlace(params) {
      this.$server.getPickupPlace(params).then((res) => {
        if (res.result === 1) {
          console.log('getPickupPlace==========================')
          let hbPickPlaces = res.hbPickPlaces;
          if (hbPickPlaces != null && hbPickPlaces.length > 0) {
            this.showSelfAddress = true;
          } else {
            return;
          }
          for (let i in hbPickPlaces) {
            if (this.selfPickupPlace == hbPickPlaces[i].id) {
              let address =
                Util.normalString(hbPickPlaces[i].shortName) +
                Util.normalString(hbPickPlaces[i].desc);
              this.selfAddress = Util.normalString(address);
            }
          }
        }
      });
    },
    /**
     * 展示一维码图片
     */
    showCodeImage() {
      this.isShowCodeImage = true;
    },
    closePic() {
      this.isShowCodeImage = false;
    },
    goLogisticsTrack() {
      // this.$router.push('logistics')
      let logistics = {
        expressNo: this.expressNo,
        expressCompany: this.expressCompany,
        expressTime: this.expressTime,
      };
      this.$router.push({
        path: "/logistics",
        query: {
          logistics: JSON.stringify(logistics),
        },
      });
    },
    /**
     * 发票
     */
    gofapiao(invoiceUrl) {
      console.log("去打印发票");
      window.location.href = invoiceUrl;
    },
    /**
     * 物流查询
     */
    //
    getLogQuery() {
      // 'expressNo=' + expressNo + "&expressCompany=" + expressCompany + "&expressTime=" + expressTime;
      let params = {
        expressNo: this.expressNo,
        expressCompany: this.expressCompany,
        expressTime: this.expressTime,
      };
      this.$server.logQuery(params).then((res) => {
        if (res.result == 1) {
          let logTracks = res.logTracks;
          try {
            var length = logTracks.length;
            console.log(length);
          } catch (err) {
            logTracks = [];
          }
          if (logTracks.length == 0) {
            this.logTracksText = "物流编号：" + this.expressNo;
            this.isShowExpressBtn = false;
          } else if (logTracks.length > 0) {
            this.logTracksText = logTracks[0].acceptStation;
            this.isShowExpressBtn = true;
          }
        }
      });
    },
    /**
     * 添加出院时间
     */
    clickAddOutDate() {
      // this.showPickerDate = true;
      this.$weui.datePicker({
        start: 1949,
        defaultValue: [1991, 6, 9],
        onChange: function (result) {
          console.log(result);
        },
        onConfirm: function (result) {
          console.log(result);
        },
        id: "datePicker",
      });
    },
    onConfirm(date) {
      let outDate = this.$util.formatTime1(date).replace(/\//g, "-");
      if (compareDate(this.userHosInDate, outDate)) {
        Toast("入院时间不能大于出院时间");
        return;
      }
      console.log(date);
      Dialog.confirm({
        title: "提示",
        message: "出院时间：" + this.$util.formatTime1(date) + "是否上传？",
      })
        .then(() => {
          // on confirm
          let params = {
            requestId: this.requestId,
            outHospitalDate: this.$util.formatTime1(date).replace(/\//g, "-"),
          };
          this.updateHosOutTime(params);
        })
        .catch(() => {
          // on cancel
          this.showPickerDate = false;
        });
    },
    /**
     * 上传出院时间
     */
    updateHosOutTime(params) {
      this.$server.updateHosOutTime(params).then((res) => {
        console.log(res);
        if (res.result == 1) {
          this.textOutDate = params.outHospitalDate;
          this.disabledDate = true;
          Toast("出院时间上传成功");
          this.showPickerDate = false;
        }
      });
    },
    // 关闭支付须知弹框
    closePayTips() {
      this.showPayTips = false;
      window.scrollTo({
        top: window.innerHeight,
        behavior: "smooth",
      });
    },

    // 获取广告对象集合
    getAdvert(that) {
      console.log("that ==> ", that);
      let params = {
        advertPosition: 2,
      };
      this.$server.getAdvertList(params).then((res) => {
        console.log("res ==> ", res);
        // if (res.result == 1) {
        //   that.advertArr = res.advertList;
        //   console.log("advertArr ==> ", this.advertArr);
        // }
      });
    },

    // 广告点击事件
    bindAdvert(item) {
      console.log("item ==> ", item);
      var advertId = item.advertId;
      console.log("点击了广告id=" + advertId);
      let advertType = item.advertType;
      if (advertType == 2) {
        // 是否需要token验证
        let isAccessToken = item.isAccessToken;
        if (isAccessToken == 1) {
          // 验证token
          this.$util.queryMedicalAccesstoken(
            this.mediacl_url,
            this.client_id,
            this.client_secret,
            (token) => {
              console.log("获取token " + token);
              let webUrl = item.advertUrl + "&token=" + token;
              console.log("webUrl " + webUrl);
              window.location.href = webUrl;
            }
          );
        }
      }
    },
  },

  components: {
    Information,
    SetNavBar,
  },
  filters: {
    // 通过局部过滤器来实现
    msgDateFormat: function (msg, pattern = "") {
      // 将字符串转换为Date类型
      var mt = new Date(msg);
      // 获取年份
      var y = mt.getFullYear();
      // 获取月份 从0开始
      var m = (mt.getMonth() + 1).toString().padStart(2, "0");
      // 获取天数
      var d = mt.getDate();
      if (pattern === "yyyy-mm-dd") {
        return y + "/" + m + "/" + d;
      }
      // 获取小时
      var h = mt.getHours().toString().padStart(2, "0");
      // 获取分钟
      var mi = mt.getMinutes().toString().padStart(2, "0");
      // 获取秒
      var s = mt.getSeconds().toString().padStart(2, "0");
      // 拼接为我们需要的各式
      return y + "/" + m + "/" + d + " " + h + ":" + mi + ":" + s;
    },
  },
};

function getCurrenDate() {
  var day2 = new Date();
  day2.setTime(day2.getTime());
  // var s2 = day2.getFullYear() + "/" + (day2.getMonth() + 1) + "/" + day2.getDate();

  return day2;
}

function addDate(date, days) {
  var d = new Date(date);
  d.setDate(d.getDate() + days);
  // var m = d.getMonth() + 1;
  return d;
}

function compareDate(d1, d2) {
  return new Date(d1.replace(/-/g, "/")) > new Date(d2.replace(/-/g, "/"));
}
</script>
<style>
.pay {
  background: #f5f8fa;
  color: #666666;
}

.address_by_self {
  font-size: 15px;
  text-align: center;
  /* margin: 20px;
    margin-top: 15px; */
  margin: 10px 0;
  color: #9b9b9b;
}

.mailaddress {
  margin-bottom: 10px;
  background-color: #fff;
}

.selfcode_cell {
  text-align: left;
}

.selfCodeItem {
  font-size: 17px;
  color: #000;
  height: 30px;
  display: inline-flex;
}

.textSelfPickeCode {
  font-size: 18px;
  color: green;
}

.selfpickPic {
  width: 100px;
  height: 28px;
}

.pickup_address {
  font-size: 14px;
  color: #666;
  margin-left: 20px;
  display: flex;
}

.location_img {
  width: 14px;
  height: 14px;
  align-self: center;
  margin-right: 10px;
}

.my_line {
  height: 1px;
  width: 100%;
  margin: 5px 0;
  background: #d9d9d9;
}

.ml_cell {
  margin-left: 20px;
}

.tipsSelf {
  font-size: 14px;
  color: #9b9b9b;
}

.zhu {
  font-size: 14px;
  color: #ec2828;
}

.hideitem {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
}

.cancelapply {
  line-height: 26px;
}

.canceapplych {
  color: green;
  border: 1px solid green;
  padding: 1px 3px;
  border-radius: 3px;
  font-size: 14px;
  margin: 5px 0;
}

.receiverAddress {
  width: 100%;
  margin-top: 10px;
}

.address_line {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  flex-direction: row;
  -webkit-flex-direction: row;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}

.blue-Parallelogram {
  display: flex;
  display: -webkit-flex;
  width: 10px;
  height: 0.5px;
  border: 1px solid #aee0fa;
  color: #333;
  transform: skew(-20deg);
  background-color: #aee0fa;
}

.red-Parallelogram {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  width: 10px;
  height: 0.5px;
  border: 1px solid #faaeae;
  color: #333;
  transform: skew(-20deg);
  background-color: #faaeae;
}

.red-Parallelogram-half {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  -webkit-flex-direction: row;
  width: 5px;
  height: 0.5px;
  border: 1px solid #faaeae;
  color: #333;
  transform: skew(-20deg);
  background-color: #faaeae;
}

/* 收货地址 */
.address_title {
  padding: 10px 15px;
  margin-top: 5px;
  /* position: relative; */
  /* display: flex; */
  /* display: -webkit-flex; */
  /* -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center */
}

.information {
  margin-bottom: 10px;
}

.title span {
  align-self: center;
}

.pay-title {
  padding: 10px 0;
}

.no_payed {
  font-size: 15px;
  font-weight: bold;
  color: #f04141;
}

#totalPayingFee {
  font-weight: bold;
  color: #01a300;
  /*font-size: 18px;*/
}

#totalFee {
  font-weight: bold;
  color: #01a300;
  /*font-size: 18px;*/
}

#paied_final_fee {
  color: #01a300;
}

#paied_final_fee_b {
  color: #f04141;
}

#no_pay_fee {
  color: #01a300;
}

#line-show {
  border: none;
}

.total-title {
  font-weight: bold;
}

.selfcode_image {
  width: 90%;
  height: calc(90% * 0.3);
  text-align: center;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  transform: rotate(90deg);
}
.selfcode_imagezr {
  width: 100%;
  height: calc(100% * 0.3);
  text-align: center;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  /* right: 0; */
  transform: rotate(90deg);
}
.selfcode_imagezr1 {
  width: 100%;
  height: calc(100% * 0.3);
  text-align: center;
  margin: auto;
  position: absolute;
  top: 260px;
  font-size: 20px;
  left: 0;
  bottom: 0;
  font-weight: bold;
  /* right: 0; */
  /* transform: rotate(90deg); */
}
.enlargerLay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: #fff;
  text-align: center;
  -webkit-text-align: center;
  justify-content: center;
  /*子元素水平居中*/
  -webkit-justify-content: center;
}

.receiver-address {
  display: flex;
  display: -webkit-flex;
  /* Safari */
}

.receiverAddr {
  font-size: 15px;
  margin-left: 15px;
  text-align: top;
  color: #666;
}

.d_line {
  border-top: 1px solid #e5e5e5;
  margin-bottom: 20px;
  margin-left: 60px;
  margin-top: 5px;
}

.v-dotted {
  border-right: 1px dashed #e5e5e5;
  height: 20px;
  width: 1px;
  margin-left: 25px;
  margin-top: -30px;
}

.logo-express {
  align-self: center;
}

.express-log {
  font-size: 13px;
  margin-left: 15px;
  /* margin-top: -5px; */
  align-self: center;
  margin-right: 60px;
}

.express-logo {
  width: 40px;
  margin-left: 10px;
}

.express-Logistics {
  margin-bottom: 10px;
}

.text-get {
  font-size: 14px;
  width: 20px;
  height: 20px;
  /* border: 2px solid #efeff4; */
  border-radius: 50%;
  background-color: #efeff4;
  text-align: center;
  margin-left: 15px;
  color: #999;
}

.address_title {
  padding: 10px 15px;
  margin-top: 5px;
  position: relative;
  display: flex;
  display: -webkit-flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.p-address-name {
  font-size: 17px;
  font-weight: bold;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.receiver-tel {
  color: #000000;
  font-weight: bold;
}

.address_detail {
  line-height: 1.5;
  margin-left: 15px;
  margin-bottom: 15px;
  color: #333333 !important;
  font-size: 14px;
}

.tips_backhome {
  width: 100%;
  height: 20px;
  background: #f60;
  padding: 10px 0 10px 0;
  position: fixed;
  z-index: 3;
  top: 0;
}

.text_tips_pay {
  color: #fff;
  font-size: 12px;
  float: left;
  margin-left: 5px;
  align-self: center;
}

.text_backhome {
  color: #fff;
  font-size: 12px;
  float: right;
  margin-right: 5px;
}

.text_backhome::after {
  content: " ";
  display: inline-block;
  height: 6px;
  width: 6px;
  border-width: 2px 2px 0 0;
  border-color: #fff;
  border-style: solid;
  -webkit-transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
  position: relative;
  /* top: -2px; */
  /* position: absolute;*/
  top: 50%;
  /* right: 5px; */
  margin-top: -4px;
}

.btnUpdateDate {
  color: #1aad19;
}
.hos-name {
  width: 120px;
}

/* 支付须知模块 */
.pay-popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: hidden;
  color: #fff;
  display: flex;
  z-index: 10;
}

.popup-paytips {
  width: 85%;
  margin: auto;
  background-color: #fff;
  border-radius: 8px;
}

.pay-notice {
  width: 100%;
  margin-top: -25px;
}

.popup-content {
  padding: 10px 15px;
  font-size: 16px;
  color: #333;
  text-align: center;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}

.content-list {
  display: flex;
}

.content-num {
  width: 20px;
  height: 20px;
  margin: 3px 5px;
  background-color: #0db17e;
  text-align: center;
  line-height: 20px;
  color: #fff;
  font-weight: 500;
  border-radius: 50%;
}

.content-item {
  margin-bottom: 20px;
  text-align: left;
  flex: 1;
}

.content-item span {
  color: #0db17e;
}

.popup-content button {
  width: 150px;
  height: 40px;
  font-size: 15px;
  line-height: 40px;
  color: #fff;
  border-radius: 25px;
  background-color: #0db17e;
}
.btn-agree {
  margin: 8px auto;
}

.paytips {
  position: fixed;
  bottom: 46px;
  width: 100%;
  padding: 20rpx 0;
  background-color: #fffada;
  font-size: 14px;
  z-index: 2;
}

.paytips-content {
  padding: 0 8px;
  color: #ff6e00;
}
.express-d {
  margin-right: 20px;
  font-size: 13px;
  color: #01a300;
}
.paytips-content span {
  color: #0db17e;
}
.bottom-view {
  margin-bottom: 120px;
}
.seefapiao {
  line-height: 14px;
  color: green;
  border: 1px solid green;
  padding: 7px 7px;
  border-radius: 3px;
  font-size: 12px;
  margin: 12px 0;
}
</style>
